






































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Icons
 ---------------------------------------- */

import FacebookIcon from '@icon/FacebookIcon.vue';
import InstagramIcon from '@icon/InstagramIcon.vue';
import LinkedInIcon from '@icon/LinkedInIcon.vue';

/* ----------------------------------------
     Transitions
 ---------------------------------------- */

import * as transition from '@router/transitions/generic/fade'

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        FacebookIcon,
        InstagramIcon,
        LinkedInIcon
    },

    data() {
        return {
            active: 'is-valid',
            inActive: 'is-invalid',
            mount: false,
            selected: '',
            value: '',
        }
    },

    computed: {
        hasFooter() {
            return this.$route.name !== 'case' || this.mount;
        },

        message() {
            return this.warning[this.selected];
        }
    },

    methods: {
        validate: email => {
            const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regex.test(email);
        },

        checkInput: function(e) {
            let current;

            const classes = this.$refs.input.classList;
            const validate = this.validate(this.value);

            if(validate && !classes.contains('is-validated') && !current) {
                current = true;
                this.selected = this.translate('newsletter.title');
                classes.add(this.active) && classes.remove(this.inActive)
            } else if(current) {
                current = false;
                this.selected = this.translate('newsletter.error');
                classes.remove(this.active);
            }
        },

        focus: function(e) {
            this.$refs.input.focus();
            !this.$refs.input.value && transition.fadeOut(this.$refs.label, 350);
        },

        unFocus: function(e) {
            const classes = this.$refs.input.classList;

            this.$refs.input.blur();
            !this.$refs.input.value && transition.fadeIn(this.$refs.label, 350);

            classes.remove(this.active);
            classes.remove(this.inActive);
        },

        submit: function(e) {
            e.preventDefault();

            const classes = this.$refs.input.classList;
            const validate = this.validate(this.value);

            if(validate) {
                this.$refs.input.value = '';
                classes.remove(this.active);
                classes.remove(this.inActive);
            } else {
                classes.add(this.inActive)
            }
        }
    },

    mounted() {
        if(this.$refs.newsletter) {
            this.$refs.newsletter.addEventListener('mouseenter', this.focus, false);
            this.$refs.newsletter.addEventListener('mouseleave', this.unFocus, false);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Footer extends Vue {}

